<template>
  <section>
    <qx-card :title="title" class="detail" v-loading="loading">
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
    </qx-card>
    <ApproveBox ref="approveBox" v-if="$route.query.type !== 'detail'" />
  </section>
</template>
<script>
import {
  getVehicleInviteRecord, // 获取详情
} from 'api/car';
// import {
//   getFileUrl,
// } from 'api';
import ApproveBox from './approve';
import formInit from './formInit';
export default {
  components: {
    ApproveBox,
  },
  data () {
    return {
      title: '申请转移',
      loading: false,
      detailData: {},
    };
  },
  methods: {
    async fnDetail (detailRes) {
      this.detailData = formInit.detail;
      this.showDetailItem(detailRes);
      this.detailData.base.tableData.data = detailRes;
      this.detailData.belong.tableData.data = detailRes;
      this.detailData.applyInfo.tableData.data = detailRes;
      this.detailData.approve.tableData.data = detailRes;
    },
    async fnApplyAndInvite (detailRes) {
      // 【再次申请】和【再次邀请】的时候需要显示的信息
      this.detailData = formInit.applyAndInvite;
      this.detailData.base.tableData.data = detailRes;
      this.detailData.belong.tableData.data = detailRes;
      // 初始化最底部的提交表单组件
      this.$refs.approveBox.setForm(detailRes, this.$route.query.type);
    },
    async fnArbitration (detailRes) {
      // 【申请平台仲裁】只需要显示基础信息
      this.detailData = formInit.arbitration;
      this.detailData.base.tableData.data = detailRes;
      this.$refs.approveBox.setForm(detailRes, this.$route.query.type);
    },
    async getData () {
      // 遇到这两个URL就阻止页面刷新
      if (this.$route.path !== '/manage/car/archives/invite/detail') {
        return;
      }
      this.loading = true;
      const detailRes = await getVehicleInviteRecord({
        applyRecordId: this.$route.query.id,
        recordType: 0,
      });
      this.loading = false;
      if (!detailRes.failed) {
        switch (this.$route.query.type) {
          case 'detail':
            this.title = '申请转移';
            this.fnDetail(detailRes);
            break;
          case 'apply':
            this.title = '申请转移';
            this.fnApplyAndInvite(detailRes);
            break;
          case 'invite':
            this.title = '再次邀请';
            this.fnApplyAndInvite(detailRes);
            break;
          case 'arbitration':
            this.title = '申请平台仲裁';
            this.fnArbitration(detailRes);
            break;
          default:
            this.title = '申请转移';
            break;
        }
      }
    },
    // 【查看】的时候需要显示的信息
    showDetailItem (detailRes) {
      if (detailRes.applyVehicleClass === 1) {
        // 自有车，显示申请说明，运营证和行驶证
        this.detailData.applyInfo = {
          label: '申请转移自有车',
          tableData: {
            title: [
              {
                prop: 'operCerti',
                label: '运营证',
                type: 'img',
              },
              {
                prop: 'drivingLicense',
                label: '行驶证',
                type: 'img',
              },
              {
                prop: 'applyRemark',
                label: '申请说明',
              },
            ],
            data: {},
            approveData: {},
          },
        };
      } else {
        // 业务招商车，临时外调车，挂靠车，显示邀请说明和附件
        this.detailData.applyInfo = {
          label: `邀请成为${detailRes.applyVehicleClassName}`,
          tableData: {
            title: [
              {
                prop: 'applyRemark',
                label: '运营证',
              },
              {
                prop: 'applyFileId',
                label: '附件',
                type: 'img',
              },
            ],
            data: {},
            approveData: {},
          },
        };
      }
    },
    async sub (formData) {
      console.log(formData);
    },
  },
  mounted () {
    this.getData();
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
    '$route.query.type': function () {
      this.getData();
    },
  },
};
</script>
<style>
</style>
